import { combineEpics } from "redux-observable";
import { epicBuyImprovement } from "./epics/epicBuyImprovement";
import { epicBuyImprovementRequest } from "./epics/epicBuyImprovementRequest";
export var epicImprovement = combineEpics(epicBuyImprovement, epicBuyImprovementRequest);



//////////////////
// WEBPACK FOOTER
// ./src/features/improvement/epicImprovement.ts
// module id = 1893
// module chunks = 3